
        var result = require("!!../../../../node_modules/css-loader/index.js!./appointmentkind.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-planner/appointmentkind.component.css
// module id = 2445
// module chunks = 1